import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import { prettifyPhone } from '../../config/common';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { addressInitialStateFromFhirAddressObject } from '../../component/reusableLogic/fhirInitialPropsToState';

const ViewContact = props => {
    const selectedVersion = useSelector(
        state => state.changeVersion.selectedVersion
    );
    const [contactState, setContactState] = useState();
    const [homeAddress, setHomeAddress] = useState({});
    const [workAddress, setWorkAddress] = useState({});
    const loading = useSelector(state => state?.backdrop?.progress);

    const formatPhoneNumber = phone => {
        if (phone?.length === 10) {
            return phone;
        } else if (phone?.length > 10) {
            let fullLength = phone?.length;
            let extraLength = fullLength - 10;
            // now exact length
            return phone?.slice(extraLength);
        }
    };

    useEffect(() => {
        debugger;
        setHomeAddress(
            addressInitialStateFromFhirAddressObject(
                contactState?.address,
                'home'
            )
        );
        setWorkAddress(
            addressInitialStateFromFhirAddressObject(
                contactState?.address,
                'work'
            )
        );
    }, [contactState?.address]);

    useEffect(() => {
        if (!props?.patientData) {
            setContactState({
                firstName: props?.relatedpersonObject?.name?.[0]?.given?.[0],
                middleName: props?.relatedpersonObject?.name?.[0]?.given?.[1],
                lastName: props?.relatedpersonObject?.name?.[0]?.given?.[2],
                suffix: props?.relatedpersonObject?.name?.[0]?.suffix?.join(
                    ', '
                ),
                prefix: props?.relatedpersonObject?.name?.[0]?.prefix?.[0],
                gender: props?.relatedpersonObject?.gender,
                birthDate: dayjs(props?.relatedpersonObject?.birthDate).format(
                    'MM/DD/YYYY'
                ),
                homePhone: props?.relatedpersonObject?.telecom?.filter(f => {
                    if (f?.system === 'phone' && f?.use === 'home') {
                        return f;
                    }
                })?.[0]?.value,
                cellPhone:
                    props?.relatedpersonObject?.telecom?.filter(f => {
                        if (f?.system === 'phone' && f?.use === 'mobile') {
                            return f;
                        }
                    })?.[0]?.value || '',
                email: props?.relatedpersonObject?.telecom?.filter(f => {
                    if (f?.system === 'email') {
                        return f;
                    }
                })?.[0]?.value,
                countryCode:
                    props?.relatedpersonObject?.telecom?.find(
                        o => o?.use == 'home'
                    )?.extension?.[0]?.valueString || '',
                address: props?.relatedpersonObject?.address,
            });
        } else {
            // todo start
            setContactState({
                firstName: props?.patientData?.name?.[0]?.given?.[0],
                middleName: props?.patientData?.name?.[0]?.given?.[1],
                lastName: props?.patientData?.name?.[0]?.given?.[2],
                suffix: props?.patientData?.name?.[0]?.suffix?.join(', '),
                prefix: props?.patientData?.name?.[0]?.prefix?.[0],
                gender: props?.patientData?.gender,
                birthDate: dayjs(props?.patientData?.birthDate).format(
                    'MM/DD/YYYY'
                ),
                homePhone: props?.patientData?.telecom?.filter(f => {
                    if (f?.system === 'phone' && f?.use === 'home') {
                        return f;
                    }
                })?.[0]?.value,
                cellPhone:
                    props?.patientData?.telecom?.filter(f => {
                        if (f?.system === 'phone' && f?.use === 'mobile') {
                            return f;
                        }
                    })?.[0]?.value || '',
                email: props?.patientData?.telecom?.filter(f => {
                    if (f?.system === 'email') {
                        return f;
                    }
                })?.[0]?.value,
                countryCode:
                    props?.patientData?.telecom?.find(o => o?.use == 'home')
                        ?.extension?.[0]?.valueString || '',
                address: props?.patientData?.address,
            });
            // todo end
        }
    }, [props?.relatedpersonObject, props?.patientData]);

    const [nameArr, setNameArr] = useState(
        props?.relatedpersonObject?.name?.[0]?.given
    );

    const tableData = [
        { relationType: 'Mother', relatedTo: 'Robert' },
        { relationType: 'Aunt', relatedTo: 'Meena' },
        { relationType: 'Brother', relatedTo: 'Shiva' },
    ];

    const addressTextGenerator = ({ width = 200, addressType } = {}) => {
        /**
         * @param addressType can take values as primary and billing
         */
        let title = '';
        let address = {};
        if (addressType === 'primary') {
            title = 'Primary Address';
            address = homeAddress;
        }

        if (addressType === 'billing') {
            title = 'Billing Address';
            address = workAddress;
            if (!address?.addressLine1) {
                return (
                    <Box sx={{ my: 1 }}>
                        <Typography>{title}</Typography>
                        <Typography>Same as primary address</Typography>
                    </Box>
                );
            }
        }

        return (
            <>
                {address?.addressLine1 && title !== 'Primary Address' && (
                    <Typography
                        mb={2}
                        color={'primary'}
                        sx={{ fontWeight: '500' }}
                    >
                        Billing Address
                    </Typography>
                )}
                <Grid container mb={2}>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography mb={1} color={'textSecondary'}>
                            Address Line 1:
                        </Typography>
                        <Typography>{address?.addressLine1 || '-'}</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography mb={1} color={'textSecondary'}>
                            Address Line 2:
                        </Typography>
                        <Typography>{address?.addressLine2 || '-'}</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography mb={1} color={'textSecondary'}>
                            {selectedVersion === 'IN'
                                ? 'City/District/Village'
                                : 'City'}
                            :
                        </Typography>
                        <Typography>{address?.city || '-'}</Typography>
                    </Grid>
                </Grid>
                <Grid container mb={2}>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography mb={1} color={'textSecondary'}>
                            State:
                        </Typography>
                        <Typography>{address?.state || '-'}</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography mb={1} color={'textSecondary'}>
                            Country:
                        </Typography>
                        <Typography>
                            {address?.country?.slice(0, 2)?.toUpperCase() ||
                                '-'}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={3}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Typography mb={1} color={'textSecondary'}>
                            Zipcode:
                        </Typography>
                        <Typography>{address?.postalCode || '-'}</Typography>
                    </Grid>
                </Grid>
            </>
        );
    };

    return (
        <>
            <Box p={2}>
                <Paper
                    elevation={2}
                    sx={{ marginBottom: '30px', padding: '20px' }}
                >
                    <Typography
                        mb={2}
                        color={'primary'}
                        sx={{ fontWeight: '500' }}
                    >
                        Personal Details
                    </Typography>
                    <Grid container mb={2}>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Title
                            </Typography>
                            <Typography>
                                {contactState?.prefix || '-'}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Suffix
                            </Typography>
                            <Typography>
                                {contactState?.suffix || '-'}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container mb={2}>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                First Name
                            </Typography>
                            <Typography>{contactState?.firstName}</Typography>
                        </Grid>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Middle Name
                            </Typography>
                            <Typography>
                                {contactState?.middleName || '-'}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Last Name
                            </Typography>
                            <Typography>{contactState?.lastName}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Birth Date
                            </Typography>
                            <Typography>
                                {contactState?.birthDate || '-'}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Gender
                            </Typography>
                            <Typography>
                                {_.capitalize(contactState?.gender)}
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper
                    elevation={2}
                    sx={{ marginBottom: '30px', padding: '20px' }}
                >
                    <Typography
                        mb={2}
                        color={'primary'}
                        sx={{ fontWeight: '500' }}
                    >
                        Relationship Details
                    </Typography>

                    {(!loading && (
                        <Box>
                            {props?.relations?.length > 0 ? (
                                <Table>
                                    <TableRow>
                                        <TableCell
                                            sx={{
                                                width: '25%',
                                                padding: '10px 0',
                                            }}
                                        >
                                            <Typography color={'textSecondary'}>
                                                Relation Type
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                width: '25%',
                                                padding: '10px 0',
                                            }}
                                        >
                                            <Typography color={'textSecondary'}>
                                                Related To
                                            </Typography>
                                        </TableCell>
                                        <TableCell
                                            sx={{
                                                width: '25%',
                                                padding: '10px 0',
                                            }}
                                        >
                                            <Typography color={'textSecondary'}>
                                                Status
                                            </Typography>
                                        </TableCell>
                                        <TableCell sx={{ width: '25%' }} />
                                    </TableRow>
                                    <TableBody>
                                        {props?.relations?.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell
                                                    sx={{ padding: '10px 0' }}
                                                >
                                                    <Typography>
                                                        {index + 1}.{' '}
                                                        {_.capitalize(
                                                            row?.relationType
                                                        )}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    sx={{ padding: '10px 0' }}
                                                >
                                                    <Typography>
                                                        {
                                                            row?.relatedTo
                                                                ?.display
                                                        }
                                                    </Typography>
                                                </TableCell>
                                                <TableCell
                                                    sx={{ padding: '10px 0' }}
                                                >
                                                    <Typography>
                                                        {row?.raw?.active
                                                            ? 'Active'
                                                            : 'In-Active'}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            ) : (
                                <Typography mb={1}>
                                    Relationship Details not found
                                </Typography>
                            )}
                        </Box>
                    )) || <>Loading...</>}
                </Paper>
                <Paper
                    elevation={2}
                    sx={{ padding: '20px', marginBottom: '30px' }}
                >
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography
                            mb={1}
                            color={'primary'}
                            sx={{ fontWeight: '500' }}
                        >
                            Contact Details
                        </Typography>
                        {/* <Box>
                            <Button
                                variant="contained"
                                sx={{ marginRight: '20px' }}
                            >
                                <CallIcon sx={{ marginRight: '5px' }} /> Call
                            </Button>
                            <Button variant="contained">
                                <EmailIcon sx={{ marginRight: '5px' }} /> Email
                            </Button>
                        </Box> */}
                    </Box>
                    {/* <Typography mb={2} color={'textSecondary'}>
                        (Available Timings: Mon - Sun, 10 AM - 10 PM)
                    </Typography> */}
                    <Grid container>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Home Phone
                            </Typography>
                            <Typography>
                                {/* {prettifyPhone(contactState?.cellPhone) || '-'} */}
                                {props?.patientData
                                    ? prettifyPhone(
                                          formatPhoneNumber(
                                              contactState?.homePhone
                                          )
                                      ) || '-'
                                    : `${
                                          contactState?.countryCode &&
                                          contactState?.cellPhone &&
                                          contactState?.countryCode
                                      }  ${
                                          prettifyPhone(
                                              formatPhoneNumber(
                                                  contactState?.cellPhone
                                              )
                                          ) || '-'
                                      }`}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Cell Phone
                            </Typography>
                            <Typography>
                                {/* {prettifyPhone(contactState?.homePhone) || '-'} */}
                                {props?.patientData
                                    ? prettifyPhone(
                                          formatPhoneNumber(
                                              contactState?.cellPhone
                                          )
                                      ) || '-'
                                    : `${
                                          contactState?.countryCode &&
                                          contactState?.countryCode
                                      }  ${prettifyPhone(
                                          formatPhoneNumber(
                                              contactState?.homePhone
                                          )
                                      )}` || '-'}
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={3}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Typography mb={1} color={'textSecondary'}>
                                Email
                            </Typography>
                            <Typography>{contactState?.email}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper elevation={2} sx={{ padding: '20px' }}>
                    <Typography
                        mb={2}
                        color={'primary'}
                        sx={{ fontWeight: '500' }}
                    >
                        Primary Address
                    </Typography>
                    {addressTextGenerator({ addressType: 'primary' })}
                    <Box sx={{ padding: '10px 0' }}>
                        <Divider />
                    </Box>
                    {addressTextGenerator({ addressType: 'billing' })}
                </Paper>
            </Box>
        </>
    );
};

export default ViewContact;
